import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import styles from "./index.module.css"
import {
  Button,
  FingerprintIcon,
  Heading,
  PwaInstallCard,
  PwaInstallSheet,
  PrivacityIcon,
  VoteIcon,
  WebIcon,
  buttonTypes,
  usePwaInstall,
} from "@cividao/components"
import { useLogos } from "../../../hooks/useLogos"
import { LOGO } from "../../../js/const"

export function WelcomeTemplate() {
  const { t } = useTranslation(["welcome", "pwa"])
  const navigate = useNavigate()
  const { logo, logoFull } = useLogos()
  const pwa = usePwaInstall({ showAlways: true })

  const handleConnect = () => {
    navigate("/login", { viewTransition: true })
  }

  const handleRegister = () => {
    navigate("/register", { viewTransition: true })
  }

  return (
    <>
      <main className={styles.container}>
        <div className={styles.content}>
          <div className={styles.logoContainer}>
            <img src={logoFull} alt="Antipartido Logo" className={styles.logo} />
          </div>
          <div className={styles.headingContainer}>
            <Heading as="h2" fontFamily="brand" color="highlighted" align="center">
              {t("title")}
            </Heading>
            <p>{t("subtitle")}</p>
          </div>

          <div className={styles.infoBox}>
            <img src={logo} alt="Antipartido Logo" className={styles.logo} />
            <Heading as="h3" fontFamily="brand" color="highlighted" align="center">
              {t("whatIs.title")}
            </Heading>
            <p>{t("whatIs.description")}</p>

            <div className={styles.features}>
              <div className={styles.featureRow}>
                <div className={styles.feature}>
                  <PrivacityIcon />
                  <span>{t("whatIs.features.anonymous")}</span>
                </div>
                <div className={styles.feature}>
                  <WebIcon />
                  <span>{t("whatIs.features.verifiable")}</span>
                </div>
              </div>
              <div className={styles.featureRow}>
                <div className={styles.feature}>
                  <FingerprintIcon />
                  <span>{t("whatIs.features.biometric")}</span>
                </div>
                <div className={styles.feature}>
                  <VoteIcon />
                  <span>{t("whatIs.features.oneVote")}</span>
                </div>
              </div>
            </div>
          </div>

          {!pwa.isInstalled && (
            <PwaInstallCard
              appIcon={LOGO}
              appName={t("pwa:appName")}
              buttonText={t("pwa:buttonText")}
              onInstall={pwa.openInstructions}
            />
          )}

          <div className={styles.buttonsContainer}>
            <Button onClick={handleConnect} isFull>
              {t("buttons.connect")}
            </Button>

            <div className={styles.divider}>
              <span className={styles.dividerLine}></span>
              <span className={styles.dividerText}>{t("or")}</span>
              <span className={styles.dividerLine}></span>
            </div>

            <Button type={buttonTypes.OUTLINE} onClick={handleRegister} isFull>
              {t("buttons.register")}
            </Button>
          </div>

          <p className={styles.faqLink} onClick={() => navigate("/faq")}>
            <span>{t("faqLink")}</span>
          </p>

          <PwaInstallSheet
            pwa={pwa}
            literals={{
              installQuestion: t("pwa:installQuestion"),
              tapToInstall: t("pwa:tapToInstall"),
              incompatibleBrowserTitle: t("pwa:incompatibleBrowserTitle"),
              incompatibleBrowserMessage: t("pwa:incompatibleBrowserMessage"),
              incompatibleBrowserCopyLink: t("pwa:incompatibleBrowserCopyLink"),
              incompatibleBrowserLinkCopied: t("pwa:incompatibleBrowserLinkCopied"),
              iosStep1: t("pwa:iosStep1"),
              iosStep2: t("pwa:iosStep2"),
              iosStep3: t("pwa:iosStep3"),
              shareText: t("pwa:shareText"),
              moreText: t("pwa:moreText"),
              addToHomeScreenText: t("pwa:addToHomeScreenText"),
            }}
            appName={t("pwa:appName")}
            appUrl={window.location.origin}
            appLogo={LOGO}
          />
        </div>
      </main>
    </>
  )
}
